/**
 * Created by lizj on 2018/5/29.
 * Mod by caozh on 2018/7/24.
 */

;(function () {
    personalMsgCtrl.$inject = ['request', 'COUNTRYS', 'PROVINCE', 'DEPARTMENT'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .constant('COUNTRYS', [
            {value: 'AF', label: 'Afghanistan'},
            {value: 'ALA', label: 'Aland Islands'},
            {value: 'AL', label: 'Albania'},
            {value: 'GBA', label: 'Alderney'},
            {value: 'DZ', label: 'Algeria'},
            {value: 'AS', label: 'American Samoa'},
            {value: 'AD', label: 'Andorra'},
            {value: 'AO', label: 'Angola'},
            {value: 'AI', label: 'Anguilla'},
            {value: 'AQ', label: 'Antarctica'},
            {value: 'AG', label: 'Antigua and Barbuda'},
            {value: 'AR', label: 'Argentina'},
            {value: 'AM', label: 'Armenia'},
            {value: 'AW', label: 'Aruba'},
            {value: 'ASC', label: 'Ascension Island'},
            {value: 'AU', label: 'Australia'},
            {value: 'AT', label: 'Austria'},
            {value: 'AZ', label: 'Azerbaijan'},
            {value: 'BS', label: 'Bahamas'},
            {value: 'BH', label: 'Bahrain'},
            {value: 'BD', label: 'Bangladesh'},
            {value: 'BB', label: 'Barbados'},
            {value: 'BY', label: 'Belarus'},
            {value: 'BE', label: 'Belgium'},
            {value: 'BZ', label: 'Belize'},
            {value: 'BJ', label: 'Benin'},
            {value: 'BM', label: 'Bermuda'},
            {value: 'BT', label: 'Bhutan'},
            {value: 'BO', label: 'Bolivia'},
            {value: 'BA', label: 'Bosnia and Herzegovina'},
            {value: 'BW', label: 'Botswana'},
            {value: 'BV', label: 'Bouvet Island'},
            {value: 'BR', label: 'Brazil'},
            {value: 'IO', label: 'British Indian Ocean Territory'},
            {value: 'BN', label: 'Brunei Darussalam'},
            {value: 'BG', label: 'Bulgaria'},
            {value: 'BF', label: 'Burkina Faso'},
            {value: 'BI', label: 'Burundi'},
            {value: 'KH', label: 'Cambodia'},
            {value: 'CM', label: 'Cameroon'},
            {value: 'CA', label: 'Canada'},
            {value: 'CV', label: 'Cape Verde'},
            {value: 'KY', label: 'Cayman Islands'},
            {value: 'CF', label: 'Central African Republic'},
            {value: 'TD', label: 'Chad'},
            {value: 'CL', label: 'Chile'},
            {value: 'CN', label: 'China (Mainland)'},
            {value: 'CX', label: 'Christmas Island'},
            {value: 'CC', label: 'Cocos (Keeling) Islands'},
            {value: 'CO', label: 'Colombia'},
            {value: 'KM', label: 'Comoros'},
            {value: 'ZR', label: 'Congo, The Democratic Republic Of The'},
            {value: 'CG', label: 'Congo, The Republic of Congo'},
            {value: 'CK', label: 'Cook Islands'},
            {value: 'CR', label: 'Costa Rica'},
            {value: 'CI', label: 'Cote D&#39;Ivoire'},
            {value: 'HR', label: 'Croatia (local name: Hrvatska)'},
            {value: 'CU', label: 'Cuba'},
            {value: 'CY', label: 'Cyprus'},
            {value: 'CZ', label: 'Czech Republic'},
            {value: 'DK', label: 'Denmark'},
            {value: 'DJ', label: 'Djibouti'},
            {value: 'DM', label: 'Dominica'},
            {value: 'DO', label: 'Dominican Republic'},
            {value: 'TP', label: 'East Timor'},
            {value: 'EC', label: 'Ecuador'},
            {value: 'EG', label: 'Egypt'},
            {value: 'SV', label: 'El Salvador'},
            {value: 'GQ', label: 'Equatorial Guinea'},
            {value: 'ER', label: 'Eritrea'},
            {value: 'EE', label: 'Estonia'},
            {value: 'ET', label: 'Ethiopia'},
            {value: 'FK', label: 'Falkland Islands (Malvinas)'},
            {value: 'FO', label: 'Faroe Islands'},
            {value: 'FJ', label: 'Fiji'},
            {value: 'FI', label: 'Finland'},
            {value: 'FR', label: 'France'},
            {value: 'FX', label: 'France Metropolitan'},
            {value: 'GF', label: 'French Guiana'},
            {value: 'PF', label: 'French Polynesia'},
            {value: 'TF', label: 'French Southern Territories'},
            {value: 'GA', label: 'Gabon'},
            {value: 'GM', label: 'Gambia'},
            {value: 'GE', label: 'Georgia'},
            {value: 'DE', label: 'Germany'},
            {value: 'GH', label: 'Ghana'},
            {value: 'GI', label: 'Gibraltar'},
            {value: 'GR', label: 'Greece'},
            {value: 'GL', label: 'Greenland'},
            {value: 'GD', label: 'Grenada'},
            {value: 'GP', label: 'Guadeloupe'},
            {value: 'GU', label: 'Guam'},
            {value: 'GT', label: 'Guatemala'},
            {value: 'GGY', label: 'Guernsey'},
            {value: 'GN', label: 'Guinea'},
            {value: 'GW', label: 'Guinea-Bissau'},
            {value: 'GY', label: 'Guyana'},
            {value: 'HT', label: 'Haiti'},
            {value: 'HM', label: 'Heard and Mc Donald Islands'},
            {value: 'HN', label: 'Honduras'},
            {value: 'HK', label: 'Hong Kong'},
            {value: 'HU', label: 'Hungary'},
            {value: 'IS', label: 'Iceland'},
            {value: 'IN', label: 'India'},
            {value: 'ID', label: 'Indonesia'},
            {value: 'IR', label: 'Iran (Islamic Republic of)'},
            {value: 'IQ', label: 'Iraq'},
            {value: 'IE', label: 'Ireland'},
            {value: 'IM', label: 'Isle of Man'},
            {value: 'IL', label: 'Israel'},
            {value: 'IT', label: 'Italy'},
            {value: 'JM', label: 'Jamaica'},
            {value: 'JP', label: 'Japan'},
            {value: 'JEY', label: 'Jersey'},
            {value: 'JO', label: 'Jordan'},
            {value: 'KZ', label: 'Kazakhstan'},
            {value: 'KE', label: 'Kenya'},
            {value: 'KI', label: 'Kiribati'},
            {value: 'KS', label: 'Kosovo'},
            {value: 'KW', label: 'Kuwait'},
            {value: 'KG', label: 'Kyrgyzstan'},
            {value: 'LA', label: 'Lao People&#39;s Democratic Republic'},
            {value: 'LV', label: 'Latvia'},
            {value: 'LB', label: 'Lebanon'},
            {value: 'LS', label: 'Lesotho'},
            {value: 'LR', label: 'Liberia'},
            {value: 'LY', label: 'Libya'},
            {value: 'LI', label: 'Liechtenstein'},
            {value: 'LT', label: 'Lithuania'},
            {value: 'LU', label: 'Luxembourg'},
            {value: 'MO', label: 'Macau'},
            {value: 'MK', label: 'Macedonia'},
            {value: 'MG', label: 'Madagascar'},
            {value: 'MW', label: 'Malawi'},
            {value: 'MY', label: 'Malaysia'},
            {value: 'MV', label: 'Maldives'},
            {value: 'ML', label: 'Mali'},
            {value: 'MT', label: 'Malta'},
            {value: 'MH', label: 'Marshall Islands'},
            {value: 'MQ', label: 'Martinique'},
            {value: 'MR', label: 'Mauritania'},
            {value: 'MU', label: 'Mauritius'},
            {value: 'YT', label: 'Mayotte'},
            {value: 'MX', label: 'Mexico'},
            {value: 'FM', label: 'Micronesia'},
            {value: 'MD', label: 'Moldova'},
            {value: 'MC', label: 'Monaco'},
            {value: 'MN', label: 'Mongolia'},
            {value: 'MNE', label: 'Montenegro'},
            {value: 'MS', label: 'Montserrat'},
            {value: 'MA', label: 'Morocco'},
            {value: 'MZ', label: 'Mozambique'},
            {value: 'MM', label: 'Myanmar'},
            {value: 'NA', label: 'Namibia'},
            {value: 'NR', label: 'Nauru'},
            {value: 'NP', label: 'Nepal'},
            {value: 'NL', label: 'Netherlands'},
            {value: 'AN', label: 'Netherlands Antilles'},
            {value: 'NC', label: 'New Caledonia'},
            {value: 'NZ', label: 'New Zealand'},
            {value: 'NI', label: 'Nicaragua'},
            {value: 'NE', label: 'Niger'},
            {value: 'NG', label: 'Nigeria'},
            {value: 'NU', label: 'Niue'},
            {value: 'NF', label: 'Norfolk Island'},
            {value: 'KP', label: 'North Korea'},
            {value: 'MP', label: 'Northern Mariana Islands'},
            {value: 'NO', label: 'Norway'},
            {value: 'OM', label: 'Oman'},
            {value: 'Other', label: 'Other Country'},
            {value: 'PK', label: 'Pakistan'},
            {value: 'PW', label: 'Palau'},
            {value: 'PS', label: 'Palestine'},
            {value: 'PA', label: 'Panama'},
            {value: 'PG', label: 'Papua New Guinea'},
            {value: 'PY', label: 'Paraguay'},
            {value: 'PE', label: 'Peru'},
            {value: 'PH', label: 'Philippines'},
            {value: 'PN', label: 'Pitcairn'},
            {value: 'PL', label: 'Poland'},
            {value: 'PT', label: 'Portugal'},
            {value: 'PR', label: 'Puerto Rico'},
            {value: 'QA', label: 'Qatar'},
            {value: 'RE', label: 'Reunion'},
            {value: 'RO', label: 'Romania'},
            {value: 'RU', label: 'Russian Federation'},
            {value: 'RW', label: 'Rwanda'},
            {value: 'BLM', label: 'Saint Barthelemy'},
            {value: 'KN', label: 'Saint Kitts and Nevis'},
            {value: 'LC', label: 'Saint Lucia'},
            {value: 'MAF', label: 'Saint Martin'},
            {value: 'VC', label: 'Saint Vincent and the Grenadines'},
            {value: 'WS', label: 'Samoa'},
            {value: 'SM', label: 'San Marino'},
            {value: 'ST', label: 'Sao Tome and Principe'},
            {value: 'SA', label: 'Saudi Arabia'},
            {value: 'SCT', label: 'Scotland'},
            {value: 'SN', label: 'Senegal'},
            {value: 'SRB', label: 'Serbia'},
            {value: 'SC', label: 'Seychelles'},
            {value: 'SL', label: 'Sierra Leone'},
            {value: 'SG', label: 'Singapore'},
            {value: 'SK', label: 'Slovakia (Slovak Republic)'},
            {value: 'SI', label: 'Slovenia'},
            {value: 'SB', label: 'Solomon Islands'},
            {value: 'SO', label: 'Somalia'},
            {value: 'ZA', label: 'South Africa'},
            {value: 'SGS', label: 'South Georgia and the South Sandwich Islands'},
            {value: 'KR', label: 'South Korea'},
            {value: 'SS', label: 'South Sudan'},
            {value: 'ES', label: 'Spain'},
            {value: 'LK', label: 'Sri Lanka'},
            {value: 'SH', label: 'St. Helena'},
            {value: 'PM', label: 'St. Pierre and Miquelon'},
            {value: 'SD', label: 'Sudan'},
            {value: 'SR', label: 'Suriname'},
            {value: 'SJ', label: 'Svalbard and Jan Mayen Islands'},
            {value: 'SZ', label: 'Swaziland'},
            {value: 'SE', label: 'Sweden'},
            {value: 'CH', label: 'Switzerland'},
            {value: 'SY', label: 'Syrian Arab Republic'},
            {value: 'TW', label: 'Taiwan'},
            {value: 'TJ', label: 'Tajikistan'},
            {value: 'TZ', label: 'Tanzania'},
            {value: 'TH', label: 'Thailand'},
            {value: 'TLS', label: 'Timor-Leste'},
            {value: 'TG', label: 'Togo'},
            {value: 'TK', label: 'Tokelau'},
            {value: 'TO', label: 'Tonga'},
            {value: 'TT', label: 'Trinidad and Tobago'},
            {value: 'TN', label: 'Tunisia'},
            {value: 'TR', label: 'Turkey'},
            {value: 'TM', label: 'Turkmenistan'},
            {value: 'TC', label: 'Turks and Caicos Islands'},
            {value: 'TV', label: 'Tuvalu'},
            {value: 'UG', label: 'Uganda'},
            {value: 'UA', label: 'Ukraine'},
            {value: 'AE', label: 'United Arab Emirates'},
            {value: 'UK', label: 'United Kingdom'},
            {value: 'US', label: 'United States'},
            {value: 'UM', label: 'United States Minor Outlying Islands'},
            {value: 'UY', label: 'Uruguay'},
            {value: 'UZ', label: 'Uzbekistan'},
            {value: 'VU', label: 'Vanuatu'},
            {value: 'VA', label: 'Vatican City State (Holy See)'},
            {value: 'VE', label: 'Venezuela'},
            {value: 'VN', label: 'Vietnam'},
            {value: 'VG', label: 'Virgin Islands (British)'},
            {value: 'VI', label: 'Virgin Islands (U.S.)'},
            {value: 'WF', label: 'Wallis And Futuna Islands'},
            {value: 'EH', label: 'Western Sahara'},
            {value: 'YE', label: 'Yemen'},
            {value: 'YU', label: 'Yugoslavia'},
            {value: 'ZM', label: 'Zambia'},
            {value: 'EAZ', label: 'Zanzibar'},
            {value: 'ZW', label: 'Zimbabwe'},
            {value: 'CW', label: 'Curacao'},
            {value: 'SX', label: 'Sint Maarten'}
        ])
        .constant('PROVINCE', {
            "China (Mainland)": ["Anhui", "Beijing", "Chongqing", "Fujian", "Gansu", "Guangdong", "Guangxi", "Guizhou", "Hainan", "Hebei", "Heilongjiang", "Henan", "Hubei", "Hunan", "Jiangsu", "Jiangxi", "Jilin", "Liaoning", "Inner Mongolia", "Ningxia", "Qinghai", "Shaanxi", "Shandong", "Shanghai", "Shanxi", "Sichuan", "Tianjin", "Xinjiang", "Tibet", "Yunnan", "Zhejiang"],
            "South Korea": ["Busan", "Chungcheongbuk-do", "Chungcheongnam-do", "Daegu", "Daejeon", "Gangwon-do", "Gwangju", "Gyeonggi-do", "Gyeongsangbuk-do", "Gyeongsangnam-do", "Incheon", "Jeju-do", "Jeollabuk-do", "Jeollanam-do", "Seoul", "Ulsan", "Sejong"],
            "United States": ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"],
            "United Kingdom": ["Aberdeenshire", "Angus", "Argyll", "Avon", "Ayrshire", "Banffshire", "Bedfordshire", "Berkshire", "Berwickshire", "Buckinghamshire", "Caerphilly", "Caithness", "Cambridgeshire", "Cardiff", "Carmarthenshire", "Cheshire", "Clackmannanshire", "Cleveland", "Clwyd", "Cornwall", "County Antrim", "County Armagh", "County Down", "County Durham", "County Fermanagh", "County Londonderry", "County Tyrone", "Cumbria", "Derbyshire", "Devon", "Dorset", "Dumfriesshire", "Dunbartonshire", "Dyfed", "East Lothian", "East Sussex", "Essex", "Fife", "Glasgow", "Gloucestershire", "Greater Manchester", "Guernsey", "Gwent", "Gwynedd", "Hampshire", "Herefordshire", "Hertfordshire", "Inverness-Shire", "Isle Of Arran", "Isle Of Barra", "Isle Of Benbecula", "Isle Of Bute", "Isle Of Canna", "Isle Of Coll", "Isle Of Colonsay", "Isle Of Cumbrae", "Isle Of Eigg", "Isle Of Gigha", "Isle Of Harris", "Isle Of Iona", "Isle Of Islay", "Isle Of Jura", "Isle Of Lewis", "Isle Of Mull", "Isle Of North Uist", "Isle Of Rum", "Isle Of Scalpay", "Isle Of Skye", "Isle Of South Uist", "Isle Of Tiree", "Isle Of Wight", "Isles Of Scilly", "Jersey", "Kent", "Kincardineshire", "Kinross-Shire", "Kirkcudbrightshire", "Lanarkshire", "Lancashire", "Leicestershire", "Lincolnshire", "London", "Merseyside", "Mid Glamorgan", "Middlesex", "Midlothian", "Morayshire", "Nairnshire", "Newport", "Norfolk", "North Humberside", "North Yorkshire", "Northamptonshire", "Northumberland", "Nottinghamshire", "Orkney Isles", "Oxfordshire", "Peeblesshire", "Pembrokeshire", "Perthshire", "Powys", "Renfrewshire", "Ross-Shire", "Roxburghshire", "Rutland", "Selkirkshire", "Shetland Islands", "Shropshire", "Somerset", "South Glamorgan", "South Humberside", "South Yorkshire", "Staffordshire", "Stirlingshire", "Suffolk", "Surrey", "Sutherland", "Tyne And Wear", "Warwickshire", "West Glamorgan", "West Lothian", "West Midlands", "West Sussex", "West Yorkshire", "Wigtownshire", "Wiltshire", "Worcestershire"],
            "India": ["Andaman and Nicobar Islands", "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chandigarh", "Chhattisgarh", "Dadra and Nagar Haveli", "Daman and Diu", "Delhi", "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jammu and Kashmir", "Jharkhand", "Karnataka", "Kerala", "Lakshadweep", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Orissa", "Puducherry", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Telangana"],
            "Turkey": ["Adana", "Adiyaman", "Afyonkarahisar", "Agri", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin", "Aydin", "Balikesir", "Bartin", "Batman", "Bayburt", "Bilecik", "Bingol", "Bitlis", "Bolu", "Burdur", "Bursa", "Canakkale", "Cankiri", "Corum", "Denizli", "Diyarbakir", "Duzce", "Edirne", "Elazig", "Erzincan", "Erzurum", "Eskisehir", "Gaziantep", "Giresun", "Gumushane", "Hakkari", "Hatay", "Igdir", "Isparta", "Istanbul", "Izmir", "Kahramanmaras", "Karabuk", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kilis", "Kirikkale", "Kirklareli", "Kirsehir", "Kocaeli", "Konya", "Kutahya", "Malatya", "Manisa", "Mardin", "Mersin", "Mugla", "Mus", "Nevsehir", "Nigde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Sanliurfa", "Siirt", "Sinop", "Sirnak", "Sivas", "Tekirdag", "Tokat", "Trabzon", "Tunceli", "Usak", "Van", "Yalova", "Yozgat", "Zonguldak"],
            "Malaysia": ["Johor", "Kedah", "Kelantan", "Kuala Lumpur", "Labuan", "Melaka", "Negeri Sembilan", "Nilai", "Pahang", "Perak", "Perlis", "Pulau Pinang", "Putrajaya", "Sabah", "Sarawak", "Selangor", "Terengganu"],
            "Vietnam": ["An Giang", "Ba Ria-Vung Tau", "Bac Giang", "Bac Kan", "Bac Lieu", "Bac Ninh", "Ben Tre", "Binh Dinh", "Binh Duong", "Binh Phuoc", "Binh Thuan", "Ca Mau", "Can Tho", "Cao Bang", "Da Nang", "Dak Lak", "Dak Nong", "Dien Bien", "Dong Nai", "Dong Thap", "Gia Lai", "Ha Giang", "Ha Nam", "Hanoi", "Ha Tinh", "Hai Duong", "Hai Phong", "Ho Chi Minh City", "Hau Giang", "Hoa Binh", "Hung Yen", "Khanh Hoa", "Kien Giang", "Kon Tum", "Lai Chau", "Lam Dong", "Lang Son", "Lao Cai", "Long An", "Nam Dinh", "Nghe An", "Ninh Binh", "Ninh Thuan", "Phu Tho", "Phu Yen", "Quang Binh", "Quang Nam", "Quang Ngai", "Quang Ninh", "Quang Tri", "Soc Trang", "Son La", "Tay Ninh", "Thai Binh", "Thai Nguyen", "Thanh Hoa", "Thua Thien Hue", "Tien Giang", "Tra Vinh", "Tuyen Quang", "Vinh Long", "Vinh Phuc", "Yen Bai"],
            "Thailand": ["Mae Hong Son", "Ratchaburi", "Chiang Mai", "Phetchaburi", "Chiang Rai", "Prachuap Khiri Khan", "Phayao", "Nan", "Chai Nat", "Lamphun", "Sing Buri", "Lampang", "Lop Buri", "Phrae", "Ang Thong", "Phra Nakhon Si Ayuttaya", "Uttaradit", "Saraburi", "Tak", "Pathum Thani", "Sukhothai", "Nonthaburi", "Phitsanulok", "Bangkok", "Kamphaeng Phet", "Samut Prakan", "Phichit", "Samut Songkhram", "Uthai Thani", "Samut Sakhon", "Nakhon Sawan", "Nakhon Pathom", "Phetchabun", "Nakhon Nayok", "Loei", "Prachin Buri", "Udon Thani", "Sa Kaew", "Nongbua Lumphoo", "Cha Choeng Sao", "Nong Khai", "Chon Buri", "Sakon Nakhon", "Rayong", "Nakhon Phanom", "Chanthaburi", "Mukdahan", "Trat", "Kalasin", "Maha Sarakham", "Chumphon", "Khon Kaen", "Ranong", "Chaiyaphum", "Surat Thani", "Roi Et", "Phang Nga", "Phuket", "Nakhon Ratchasima", "Krabi", "Buri Ram", "Nakhon Si Thammarat", "Surin", "Phatthalung", "Si Sa Ket", "Trang", "Ubon Ratchathani", "Satun", "Umnad Chareun", "Song Khla", "Yasothon", "Pattani", "Yala", "Kanchanaburi", "Narathiwat", "Suphan Buri"]
        })
        .constant('DEPARTMENT', [
            'Director/CEO/General Manager',
            'Sales',
            'Purchasing',
            'Technical &amp; Engineering',
            'Other',
            'Administrative',
            'Marketing',
            'Owner/Entrepreneur'
        ])
        .controller('personalMsgCtrl', personalMsgCtrl)
    ;

    function personalMsgCtrl(request, COUNTRYS, PROVINCE, DEPARTMENT) {
        this.$onInit = onInit();
        this.$onChanges = bindingsOnChanges();

        var vm = this;
        var util = DSSX.util;

        var checkFormData = {
            checkFirstName: function () {
                var firstName = vm.d.form.firstName;

                if (!firstName) {
                    vm.d.errMsg.firstName = validatorFn('required', {requiredName: ' 姓'});
                    return false;
                }

                vm.d.errMsg.firstName = '';
                return true;
            },
            checkLastName: function () {
                var lastName = vm.d.form.lastName;

                if (!lastName) {
                    vm.d.errMsg.lastName = validatorFn('required', {requiredName: ' 名'});
                    return false;
                }

                vm.d.errMsg.lastName = '';
                return true;
            },
            checkSex: function () {
                var sex = vm.d.form.sex;

                if (!sex) {
                    vm.d.errMsg.sex = validatorFn('requiredSel', {requiredName: ' 性别'});
                    return false;
                }

                vm.d.errMsg.sex = '';
                return true;
            },
            checkEmail: function () {
                var email = vm.d.form.email;
                if (!email) {
                    vm.d.errMsg.email = validatorFn('requiredEmail', {requiredName: '邮箱'});
                    return false;
                }

                vm.d.errMsg.email = '';
                return true;
            },
            checkBakEmail: function () {
                var bakEmail = vm.d.form.bakEmail;
                var emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;

                if (bakEmail) {
                    if (!emailReg.test(bakEmail)) {
                        vm.d.errMsg.bakEmail = validatorFn('formatErr', {validateName: '备用邮箱 '});
                        return false;
                    }
                }

                vm.d.errMsg.bakEmail = '';
                return true;
            },
            checkCountry: function () {
                var country = vm.d.form.address.country;

                if (!country) {
                    vm.d.errMsg.country = validatorFn('requiredSel', {requiredName: ' 国家/地区'});
                    return false;
                }

                vm.d.errMsg.country = '';
                return true;
            },
            checkProvinceInput: function () {
                var provinceInput = vm.d.provinceInput;

                if (!provinceInput) {
                    vm.d.errMsg.provinceInput = validatorFn('required', {requiredName: ' 省/州'});
                    return false;
                }

                vm.d.errMsg.provinceInput = '';
                return true;
            },
            checkProvinces: function () {
                var provinces = vm.d.provinces;

                if (!provinces) {
                    vm.d.errMsg.provinces = validatorFn('requiredSel', {requiredName: ' 省/州'});
                    return false;
                }

                vm.d.errMsg.provinces = '';
                return true;
            },
            checkCity: function () {
                var city = vm.d.form.address.city;

                if (!city) {
                    vm.d.errMsg.city = validatorFn('requiredNoEmpty', {requiredName: '城市'});
                    return false;
                }

                vm.d.errMsg.city = '';
                return true;
            },
            checkStreet: function () {
                var street = vm.d.form.address.street;

                if (!street) {
                    vm.d.errMsg.street = validatorFn('requiredNoEmpty', {requiredName: '街道地址'});
                    return false;
                }

                vm.d.errMsg.street = '';
                return true;
            },
            checkPostCode: function () {
                var postCode = vm.d.form.address.postCode;
                var postCodeReg = /^[0-9]{6}$/;

                if (!postCode) {
                    vm.d.errMsg.postCode = validatorFn('requiredNoEmpty', {requiredName: '邮政编码'});
                    return false;
                }

                if (!postCodeReg.test(postCode)) {
                    vm.d.errMsg.postCode = validatorFn('formatErr', {validateName: '邮政编码'});
                    return false;
                }

                vm.d.errMsg.postCode = '';
                return true;
            },
            checkCountryNo: function () {
                var countryNo = vm.d.form.countryNo;
                var countryNoReg = /^[1-9]{1,4}$/;

                if (!countryNo) {
                    vm.d.errMsg.countryNo = validatorFn('requiredNoEmpty', {requiredName: '国家代码 '});
                    return false;
                }

                if (!countryNoReg.test(countryNo)) {
                    vm.d.errMsg.countryNo = validatorFn('formatErr', {validateName: '国家代码 '});
                    return false;
                }

                vm.d.errMsg.countryNo = '';
                return true;
            },
            checkAreaNo: function () {
                var areaNo = vm.d.form.areaNo;
                var areaNoReg = /^[0-9]{1,4}$/;

                if (!areaNo) {
                    vm.d.errMsg.areaNo = validatorFn('requiredNoEmpty', {requiredName: '地区区号 '});
                    return false;
                }

                if (!areaNoReg.test(areaNo)) {
                    vm.d.errMsg.areaNo = validatorFn('formatErr', {validateName: '地区区号 '});
                    return false;
                }

                vm.d.errMsg.areaNo = '';
                return true;
            },
            checkTel: function () {
                var tel = vm.d.form.tel;
                var telReg = /^[1-9][0-9]{6,9}$/;

                if (!tel) {
                    vm.d.errMsg.tel = validatorFn('requiredNoEmpty', {requiredName: '号码 '});
                    return false;
                }

                if (!telReg.test(tel)) {
                    vm.d.errMsg.tel = validatorFn('formatErr', {validateName: '号码 '});
                    return false;
                }

                vm.d.errMsg.tel = '';
                return true;
            },
            checkFaxCountryNo: function () {
                var faxCountryNo = vm.d.form.faxCountryNo;
                var faxCountryNoReg = /^[1-9]{1,4}$/;

                if (faxCountryNo) {
                    if (!faxCountryNoReg.test(faxCountryNo)) {
                        vm.d.errMsg.faxCountryNo = validatorFn('formatErr', {validateName: '国家代码 '});
                        return false;
                    }
                }

                vm.d.errMsg.faxCountryNo = '';
                return true;
            },
            checkFaxAreaNo: function () {
                var faxAreaNo = vm.d.form.faxAreaNo;
                var faxAreaNoReg = /^[0-9]{1,4}$/;

                if (faxAreaNo) {
                    if (!faxAreaNoReg.test(faxAreaNo)) {
                        vm.d.errMsg.faxAreaNo = validatorFn('formatErr', {validateName: '地区区号 '});
                        return false;
                    }
                }

                vm.d.errMsg.faxAreaNo = '';
                return true;
            },
            checkFaxTel: function () {
                var faxTel = vm.d.form.faxTel;
                var faxTelReg = /^[1-9][0-9]{6,9}$/;

                if (faxTel) {
                    if (!faxTelReg.test(faxTel)) {
                        vm.d.errMsg.faxTel = validatorFn('formatErr', {validateName: '号码 '});
                        return false;
                    }
                }

                vm.d.errMsg.faxTel = '';
                return true;
            },
            checkPhone: function () {
                var phone = vm.d.form.phone;
                var phoneReg = /^1[34578]\d{9}$/;

                if (phone) {
                    if (!phoneReg.test(phone)) {
                        vm.d.errMsg.phone = validatorFn('formatErr', {validateName: '手机'});
                        return false;
                    }
                }

                vm.d.errMsg.phone = '';
                return true;
            }
        };

        vm.d = {
            form: {
                firstName: '',
                lastName: '',
                sex: '',
                email: '',
                bakEmail: '',
                address: {
                    city: '',//"城市",
                    country: '',//"国家、地区",
                    postCode: '',//"邮编",
                    province: '',//"省",
                    street: ''//"街道"
                },
                countryNo: '',
                areaNo: '',
                tel: '',
                faxCountryNo: '', //"传真国家代码",
                faxAreaNo: '',//"传真区域",
                faxTel: '',//"传真",
                phone: '',
                dept: '',
                job: ''
            },
            isEdit: false,
            errMsg: {
                firstName: '',
                lastName: '',
                sex: '',
                email: '',
                bakEmail: '',
                country: '',
                provinces: '',
                provinceInput: '',
                city: '',
                street: '',
                postCode: '',
                countryNo: '',
                areaNo: '',
                tel: '',
                faxCountryNo: '', //"传真国家代码",
                faxAreaNo: '',//"传真区域",
                faxTel: '',//"传真",
                phone: '',
                dept: ''
            },
            info: {},
            isShowUpdateEmail: false,
            countryList: COUNTRYS,
            provinceList: PROVINCE,
            department: DEPARTMENT,
            provinces: '',
            provinceInput: '',
            showProvinceSel: false,//是否显示省级的下拉框
            pendingCommit: false//是否正在提交
        };

        vm.f = {
            checkFormData: checkFormData,
            submit: submit,
            changeEmail: changeEmail,
            getEmail: getEmail,
            judgeHasNextCate: judgeHasNextCate,
            setProvince: setProvince
        };

        function onInit() {
            loadPerInfo().then(function (info) {
                vm.d.info = info;
                vm.d.form.email = info.email || '';

                setFormData();
            });
        }

        function bindingsOnChanges() {

        }

        //设置表单数据回显
        function setFormData() {
            var info = vm.d.info;
            var address = info.address || {};
            var country = address.country;
            var type = 'input';
            vm.d.showProvinceSel = false;

            for (var attr in vm.d.provinceList) {
                if (vm.d.provinceList.hasOwnProperty(attr)) {
                    if (attr === country) {
                        vm.d.showProvinceSel = true;
                        type = 'select';
                        break;
                    }
                }
            }

            vm.d.form.address = info.address;

            if (type === 'select') {
                vm.d.provinces = info.address.province;
            }
            if (type === 'input') {
                vm.d.provinceInput = info.address.province;
            }

            vm.d.form.areaNo = info.areaNo;
            vm.d.form.countryNo = info.countryNo;
            vm.d.form.dept = info.dept;
            vm.d.form.email = info.email;
            vm.d.form.faxAreaNo = info.faxAreaNo;
            vm.d.form.faxCountryNo = info.faxCountryNo;
            vm.d.form.faxTel = info.faxTel;
            vm.d.form.firstName = info.firstName;
            vm.d.form.job = info.job;
            vm.d.form.lastName = info.lastName;
            vm.d.form.phone = info.phone;
            vm.d.form.sex = info.sex;
            vm.d.form.bakEmail = info.spareEmail;
            vm.d.form.tel = info.tel;
        }

        /**
         * 设置省级的信息
         * @param type 'input' || 'select' 判断是下拉框的数据还是输入框的数据
         */
        function setProvince(type) {
            if (type === 'input') {
                vm.d.form.address.province = vm.d.provinceInput;
                checkFormData.checkProvinceInput();
            }

            if (type === 'select') {
                vm.d.form.address.province = vm.d.provinces;
                checkFormData.checkProvinces();
            }
        }

        //判断选择的国家是否有下一级省市级类目
        function judgeHasNextCate() {
            var country = vm.d.form.address.country;
            var type = 'input';
            vm.d.showProvinceSel = false;

            for (var attr in vm.d.provinceList) {
                if (vm.d.provinceList.hasOwnProperty(attr)) {
                    if (attr === country) {
                        vm.d.showProvinceSel = true;
                        type = 'select';
                        break;
                    }
                }
            }

            checkFormData.checkCountry();
            (type === 'input') && (vm.d.provinceInput = '');
            setProvince(type);
        }

        //打开修改邮箱的弹窗
        function changeEmail() {
            vm.d.isShowUpdateEmail = true;
        }

        //获得弹窗修改的email的值
        function getEmail(e) {
            vm.d.form.email = e.email;
        }

        //加载个人信息
        function loadPerInfo() {
            return request.get('/usr/api/loadPerInfo', {}, true)
                .then(successCallback, errorCallback)
                ;

            function successCallback(res) {
                return util.safe(res, 'data.personalInfo', {});
            }

            function errorCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'personal-msg.js',
                    funcName: 'loadPerInfo',
                    text: '加载个人信息失败'
                });
                return {};
            }
        }

        //表单提交
        function submit() {
            var result = globalValidatorData();

            if (!result) {
                layer.msg("请确认数据无误后再提交", {icon: 2});
                return;
            }

            if (vm.d.form.email === vm.d.form.bakEmail) {
                layer.msg("备用邮箱不能与验证邮箱一致", {icon: 2});
                return;
            }

            if (vm.d.pendingCommit) {
                return;
            }

            vm.d.pendingCommit = true;
            var data = handleFormData();
            updatePerInfo(data)
                .finally(function () {
                    vm.d.pendingCommit = false;
                })
            ;

        }

        //更新个人信息
        function updatePerInfo(data) {
            return request.post('/usr/api/updatePerInfo', {}, data, true)
                .then(successCallback, errorCallback)
                ;

            function successCallback(res) {
                if (res.code === 0) {
                    layer.msg("提交成功", {icon: 1});
                    onInit();
                    vm.d.isEdit = false;
                }
            }

            function errorCallback(error) {
                if (error.data.data.code === 5) {
                    layer.msg("该邮箱已被其他用户使用", {icon: 5});
                } else {
                    DSSX.dialog.err(error, {
                        moduleName: 'personal-msg.js',
                        funcName: 'updatePerInfo',
                        text: '更新个人信息失败'
                    });
                }
            }
        }

        //处理表单的数据
        function handleFormData() {
            var data = {};
            var form = angular.copy(vm.d.form);

            data.address = form.address;
            data.areaNo = form.areaNo;
            data.countryNo = form.countryNo;
            data.dept = form.dept;
            data.email = form.email;
            data.faxAreaNo = form.faxAreaNo;
            data.faxCountryNo = form.faxCountryNo;
            data.faxTel = form.faxTel;
            data.firstName = form.firstName;
            data.job = form.job;
            data.lastName = form.lastName;
            data.phone = form.phone;
            data.sex = form.sex;
            data.spareEmail = form.bakEmail;
            data.tel = form.tel;

            return data;
        }

        //全局校验数据
        function globalValidatorData() {
            var result = [];

            result.push(checkFormData.checkFirstName());
            result.push(checkFormData.checkLastName());
            result.push(checkFormData.checkSex());
            result.push(checkFormData.checkEmail());
            result.push(checkFormData.checkCountry());
            vm.d.showProvinceSel && result.push(checkFormData.checkProvinces());
            vm.d.showProvinceSel || result.push(checkFormData.checkProvinceInput());
            result.push(checkFormData.checkCity());
            result.push(checkFormData.checkStreet());
            result.push(checkFormData.checkPostCode());
            result.push(checkFormData.checkCountryNo());
            result.push(checkFormData.checkAreaNo());
            result.push(checkFormData.checkTel());

            return result.indexOf(false) === -1;
        }

        // 验证器 返回错误信息
        function validatorFn(type, text) {

            text = text || {
                requiredName: '',
                validateName: ''
            };
            var validator = {
                required: '请填写' + text.requiredName,
                requiredSel: '请选择' + text.requiredName,
                requiredEmail: '请设置' + text.requiredName,
                formatErr: text.validateName + '格式不正确',
                requiredNoEmpty: text.requiredName + '不能为空'
            };

            return validator[type];
        }

    }
})();